import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const LastName = ({ labels, errors, touched, ...rest }) => {
  return (
    <>
      <Label labelName={labels.LAST_NAME} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.lastName && touched.lastName ? 'error' : ''
        }`}
      >
        <Field
          name="lastName"
          type="text"
          className="select-style"
          placeholder={labels.LAST_NAME}
          {...rest}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.lastName}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

LastName.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default LastName;
